export default __webpack_public_path__ + "static/media/sc9.cf6a455a.mp4";